import MainClass, { MAIN_CLASS_PARAMS } from "../utils/mainClass";

import { _animate } from "../utils/_animate";
import { _event } from "../utils/_event";
import { _inputValidation } from "../utils/_inputValidation";
import { _lazyLoad } from "../utils/_lazyLoad";
import { _lightbox } from "../utils/_lightbox";
import { _splitText } from "../utils/_splitText";
import gsap from "gsap";

class ContactUs extends MainClass {
	el: {
		inputs: HTMLInputElement[];
	};
	validations: _inputValidation[];
	timer: number | null;

	constructor(props: MAIN_CLASS_PARAMS) {
		super(props);

		this.el = {
			inputs: [
				...this.selector.querySelectorAll("input"),
				...this.selector.querySelectorAll("textarea"),
			],
		};

		this.validations = [];

		this.timer = null;

		this.init();
	}

	init() {
		// for lazyload
		_lazyLoad();

		// for animate
		new _animate();

		// for validation
		this.el.inputs.forEach((item) => {
			const _item = item;
			const _name = _item.getAttribute("name")?.toLowerCase() || "";

			const _required =
				_item.dataset.required && _item.dataset.required === "true"
					? true
					: false;

			const _validation = new _inputValidation({
				target: _item,
				type: _item.getAttribute("type") || null,
				required: _required,
				validations: [
					...(_name.includes("email") ? ["email"] : []), // validate if email
					...(_name.includes("contact") ||
					_name.includes("phone") ||
					_name.includes("number")
						? ["phone-number"]
						: []), // control number input if phone number
				],
				events: {
					input: () => {
						// this.listen();
					},
					blur: () => {
						this.listen();
					},
				},
			});

			this.validations.push(_validation);
		});
		this.listen();

		// for submit btn
		this.selector.querySelectorAll(".js-submit-btn").forEach((item) => {
			item.addEventListener("click", (e) => {
				e.preventDefault();

				this.submit();
			});
		});

		// for popup
		this.selector.querySelectorAll("a").forEach((item) => {
			const _item = item as HTMLElement;

			const _href = _item.getAttribute("href");
			if (!_href) return;
			const _popup = _href.startsWith("#")
				? document.querySelector(_href)
				: null;

			if (!_popup) return;

			_item.addEventListener("click", (e) => {
				e.preventDefault();

				let _div: HTMLElement | null = null;

				new _lightbox({
					target: _popup,
					events: {
						beforeShow: (instance) => {
							_div = document.createElement("div");
							instance.content.original.prepend(_div);
							_div.classList.add("flex", "justify-end");

							_div.appendChild(instance.el.btn.close);
							const _span = document.createElement("span");
							_span.innerText = "Close";
							instance.el.btn.close.appendChild(_span);
							instance.el.btn.close.classList.remove(
								"fixed",
								"p-4",
								"text-white",
								"hover:text-red-500",
							);
							instance.el.btn.close.classList.add(
								"relative",
								"flex",
								"items-center",
								"gap-1",
								"font-sans",
								"text-sm",
								"text-neutral-60",
								"[&_svg]:w-4",
							);
						},
						afterClose: () => {
							if (_div) _div.remove();
						},
					},
				});
			});
		});

		// console.log("ContactUs", this);
	}

	listen() {
		let _valid = true;

		// find which input has value
		this.el.inputs.forEach((item) => {
			const _item = item;
			const _validation = this.validations.find(
				(item) => item.target === _item,
			);

			if (
				_validation &&
				_validation.required &&
				(_validation.status === "error" || _validation.target.value.length <= 0)
			)
				_valid = false;
		});

		// enable/disable submit btn
		this.selector.querySelectorAll(".js-submit-btn").forEach((item) => {
			item.toggleAttribute("disabled", !_valid);
			item.classList.toggle("form-submit-success", _valid);
		});
	}

	submit(status?: string) {
		let _error = false;

		// validate each inputs
		this.validations.forEach((item) => {
			_event.dispatch(item.target, "blur");

			if (item.status === "error") _error = true;
		});

		if (status === "bypass") _error = false;

		// if error, return
		if (_error) {
			// hide message
			this.hideMessage();

			return;
		}

		// show message
		this.showMessage();

		// collect data
		const _formData: Record<string, string> = {};
		this.validations.forEach((item) => {
			const _target = item.target as HTMLInputElement;
			const _name = _target.name;

			_formData[_name] = _target.value;
		});

		// send to backend
		fetch("/wp-json/custom/v1/submit-form", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"X-WP-Nonce": wpApiSettings?.nonce ?? "", // optional nếu bạn có nonce
			},
			body: JSON.stringify(_formData),
		})
			.then((res) => res.json())
			.then((result) => {
				if (!result.success) {
					alert("Submit failed: " + result.error);
				}

				this.listen();
				window.dataLayer = window?.dataLayer || [];
				window?.dataLayer.push({
					event: "formSubmitSuccess",
					formName: "contact_us",
				});
			})
			.catch((err) => {
				console.error("API error", err);
			});

		// empty all inputs
		this.validations.forEach((item) => {
			const _target = item.target;

			if (_target.type === "checkbox" || _target.type === "radio") {
				_target.checked = false;
			} else {
				_target.value = "";
			}
		});
	}

	showMessage() {
		this.selector.querySelectorAll(".js-submit-message").forEach((item) => {
			const _item = item as HTMLElement;
			_item.style.display = "block";

			const _text = new _splitText({ target: _item });

			gsap.fromTo(
				_item.querySelectorAll(".word"),
				{
					y: (index: number, target: HTMLElement) => {
						return target.classList.contains("word")
							? (target.parentNode as HTMLElement).offsetHeight
							: 20;
					},
				},
				{
					y: 0,
					duration: 0.5,
					stagger: 0.05,
					onComplete: () => {
						_text.split.revert();

						this.timer = setTimeout(() => {
							this.hideMessage();
						}, 5000);
					},
				},
			);
		});
	}

	hideMessage() {
		this.selector.querySelectorAll(".js-submit-message").forEach((item) => {
			(item as HTMLElement).style.display = "none";
		});

		clearTimeout(this.timer);
	}
}

export default ContactUs;
